import React, { Component } from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";
import StaleLoader from "components/StaleLoader";
import gql from "graphql-tag";

const loadingOverlayQuery = gql`
  query loadingOverlayQuery {
    showLoadingOverlay @client
  }
`;

export default class LoadingOverlay extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const { children } = this.props;

    return (
      <Query query={loadingOverlayQuery}>
        {({ data: { showLoadingOverlay } }) => (
          <StaleLoader loading={showLoadingOverlay}>{children}</StaleLoader>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js